<script>
    import {replace} from "svelte-spa-router";
    import {docs,historial,kits,logueo} from "../store.js";
    import {beforeUpdate,onMount} from "svelte";
    export let params;
    let total = 0,total2=0,gastos= 0,pagos= 0,tarjeta =0, efectivo = 0, cambio = 0, sobrante = 0,cambioCierre = 0;
    let kitG = 0, kitP = 0;
    let nota = "";
    let empleados = [];
    let actual = new Date();
    let texto;
    let resultados = {};
    let local;
    onMount(()=>{
        local = $docs.find((el)=>el._id == params.id);
        empleados = $docs.filter((el)=>el._id.includes('empleado:'));
        actual = new Date();

        texto = `${actual.getDate()}/${actual.getMonth()+1}/${actual.getFullYear()}`;
        if (empleados.length > 0){
            actualizar();
        }
        if (!$logueo){
			replace('/');
        }
    })
    beforeUpdate(()=>{
        //historial
        if ($historial){
			$historial = $docs.filter((el)=>{
				return (el._id.includes("registro:") && esActual(el.fecha));//agregar q sea el mismo dia q actual.
            })
            .filter((el)=>el.idLocal == params.id)
            if (local){
                nota = $docs.filter((el)=>el._id.includes(`nota:${local.nombre}`))[0].texto;
                verSobrante();
            }
            $historial.sort((a,b)=>{
				let dato = new Date(b.fecha) - new Date(a.fecha);
				return dato;
            });
            if (local){
                verCambio();
            }
            //fin sobrante
			$kits = {
				Grande: 0,
				Chico: 0
			}
			$historial.forEach((el)=>{
				if (el.detalle == "Tatuaje"){
					if (el.kit){
						$kits[el.kit] += 1;
					}
				}
				if (el.tipo == "Kit"){
						$kits[el.tamano] += el.cantidad;
				}
			})
        }
        //total
        tarjeta = 0; efectivo = 0; gastos = 0;pagos = 0; total2 = 0; total = 0; cambio = 0;sobrante = 0;cambioCierre = 0;
			for(let i=0;i<$historial.length;i++){
				let item = $historial[i];
                console.log('dia: ', item);
				switch(item.tipo){
					case "Ingreso":
						if (item.efectivo){
							efectivo+= Number(item.monto);
						} else {
							tarjeta+= Number(item.monto);
						}
						break;
					case "Pago":
						pagos += Number(item.monto);
						break;
					case "Gasto":
						gastos += Number(item.monto);
                        break;		
                    case "Cambio":
						cambio += Number(item.monto);
						break;		
					case "Sobrante":
						sobrante += Number(item.monto);
                        break;	
                    case "CambioCierre":
                        cambioCierre += Number(item.monto);
                        break;
					}	
            }
        total = cambio + (efectivo + tarjeta) - (gastos + pagos + cambioCierre); 
        total2 = cambio + (efectivo + tarjeta);
        //empleados
        if (empleados.length > 0){
            actualizar();
        }
    })
    function verCambio(){
		let caja = $docs
		.filter((el)=>el._id.includes(`caja:${local.nombre}`))
		.filter((el)=>{
			let fechael = new Date(el.fecha);
			let fecha = new Date(actual);
			fechael.setHours(0,0,0,0);
			fecha.setHours(0,0,0,0);
			return fechael.getTime() < fecha.getTime()
		})
		.sort((a,b)=>{
			let fechaA = new Date(a.fecha);
			let fechaB = new Date(b.fecha);
			fechaA.setHours(0,0,0,0);
			fechaB.setHours(0,0,0,0);
			return fechaB.getTime() - fechaA.getTime()
		})
		console.log("esta");
		console.log(caja);
		if (caja){
			$historial.push({tipo:"Cambio",detalle:"Cambio día anterior",monto:caja[0].cambio});
		}
	}
	function verSobrante(){
			let caja = $docs
			.filter((el)=>el._id.includes(`caja:${local.nombre}`))
			.find((el)=>{
				let fechael = new Date(el.fecha);
				let fecha = new Date(actual);
				fechael.setHours(0,0,0,0);
				fecha.setHours(0,0,0,0);
				return fechael.getTime() === fecha.getTime()
			})
			if (caja){
				let final = actual;
				final.setHours(23,59,59,59);
				$historial.push({tipo:"CambioCierre",detalle:"Cambio",monto:caja.cambio,fecha:final});
				$historial.push({tipo:"Sobrante",detalle:"Sobrante",monto:caja.sobrante,fecha:final});
				$historial.push({tipo:"Cerrar",detalle:"Caja Cerrada",fecha:final});
			}
	}
    function esActual(f){
		let fecha = new Date(f);
		let actualDia = actual.getDate();
		let actualMes = actual.getMonth() + 1;
		let actualAno = actual.getFullYear();
		let fechaDia = fecha.getDate();
		let fechaMes = fecha.getMonth() + 1;
		let fechaAno = fecha.getFullYear();
		return (actualDia == fechaDia && actualMes == fechaMes && actualAno == fechaAno);
	}
    function siguienteFecha(){
		//si es menor a hoy, agregar un dia
		let fechaNueva = actual;
        fechaNueva.setDate(fechaNueva.getDate() + 1);
        actual = fechaNueva;
		texto = `${actual.getDate()}/${actual.getMonth()+1}/${actual.getFullYear()}`;
	}
	function anteriorFecha(){
		let fechaNueva = actual;
		fechaNueva.setDate(fechaNueva.getDate() - 1);
		actual = fechaNueva;
		texto = `${actual.getDate()}/${actual.getMonth()+1}/${actual.getFullYear()}`;
	}
	function reset(){
        let fecha = new Date();	
        actual = fecha;
		texto = `${actual.getDate()}/${actual.getMonth()+1}/${actual.getFullYear()}`;
    }
    //empleados
    function actualizar(){
        let lista = {};
		empleados.forEach((item)=>{
			lista[item.sobrenombre] = {nombre:item.sobrenombre, perfos: 0, tatuajes: 0, pagos: 0 };
        });
		$historial.forEach((item)=>{
			if (item.empleado && lista[item.empleado]){
				switch(item.tipo){
					case "Ingreso":
						if (item.detalle == "Perforación"){
							lista[item.empleado].perfos += 1 * item.cantidad;
						} else {
							lista[item.empleado].tatuajes += 1;
						}
						break;
					case "Pago":
						lista[item.empleado].pagos += Number(item.monto);
						break;
					case "Aguinaldo":
						lista[item.empleado].pagos += Number(item.monto);
						break;
				}
			} else if (item.empleado && !lista[item.empleado]) {
                lista[item.empleado] = {nombre:item.empleado, perfos: 0, tatuajes: 0, pagos: 0 };
                switch(item.tipo){
					case "Ingreso":
						if (item.detalle == "Perforación"){
							lista[item.empleado].perfos += 1 * item.cantidad;
						} else {
							lista[item.empleado].tatuajes += 1;
						}
						break;
					case "Pago":
						lista[item.empleado].pagos += Number(item.monto);
						break;
					case "Aguinaldo":
						lista[item.empleado].pagos += Number(item.monto);
						break;
				}
            }
		});
		resultados = lista;
	}
</script>
<div class="p-4 w-full sm:w-3/4 flex flex-col">
	<div class="flex w-full items-center">
		<a href="#/locales" class="w-full bg-red-500 rounded shadow text-white m-2 p-2 cursor-pointer flex items-center justify-center hover:bg-red-300 hover:shadow-2">
			<i class="ri-arrow-left-line" />
			Volver
		</a>
    </div>
    <!--total-->
	<div class="w-full p-2 bg-white w-full my-2 rounded shadow flex flex-col">
        <div class="w-full flex items-center justify-center">
            <div class="m-2 w-full flex flex-col items-center justify-center">
                <span class="font-bold">Total</span>
                <p class="text-xl">${total2}</p>
            </div>
            <div class="m-2 w-full flex flex-col items-center justify-center">
                <span class="font-bold">Total Neto</span>
                <p class="text-xl">${total}</p>
            </div>
        </div>
        <div class="w-full flex items-center justify-center">
            <p class="m-2 w-full flex justify-center"><span class="font-bold">Gastos:</span> ${gastos}</p>
            <p class="m-2 w-full flex justify-center"><span class="font-bold">Pagos:</span> ${pagos}</p>
        </div>
        <div class="w-full flex items-center justify-center">
            <p class="m-2 w-full flex justify-center"><span class="font-bold">Tarjeta:</span> ${tarjeta}</p>
            <p class="m-2 w-full flex justify-center"><span class="font-bold">Efectivo:</span> ${efectivo}</p>
        </div>
        <div class="w-full flex items-center justify-center">	
            <p class="m-2 w-full flex justify-center"><span class="font-bold">Cambio:</span>${cambio}</p>		
            <p class="m-2 w-full flex justify-center"><span class="font-bold">Sobrante:</span>${sobrante}</p>
        </div>
    </div>
    <!--notas-->
    <div class="bg-white w-full h-full rounded shadow flex flex-col justify-center items-center p-2 mb-2">
        <p class="font-bold">Notas:</p>
        <p>{nota}</p>
    </div>
    <!--kits-->
    <div class="bg-white w-full h-full rounded shadow flex flex-col justify-center items-center p-2 mb-2">
        <div class="w-full flex items-center justify-center">
            <div class="w-full items-center justify-center text-sm font-bold">Kit Grandes: {$kits.Grande}</div>
            <div class="w-full items-center justify-center text-sm font-bold">Kit Pequeños: {$kits.Chico}</div>
        </div>
    </div>
    <!--empleados-->
    <div class="bg-white w-full h-full rounded shadow flex flex-col justify-center items-center p-2 mb-2">
        <div class="w-full flex flex-col items-center justify-start">
            {#each Object.values(resultados) as item}
                {#if item.tatuajes > 0 || item.perfos > 0 || item.pagos > 0}
                <div class="w-full border-b border-gray-200 m-2 flex flex-col">
                    <span class="text-md font-bold">{item.nombre}</span>
                    <div class="w-full flex items-center justify-between">
                        <div class="flex flex-col w-full">
                            <span class="text-xs font-bold">Tatuajes</span>
                            {item.tatuajes}
                        </div>
                    <div class="flex flex-col w-full">
                        <span class="text-xs font-bold">Perforaciones</span>
                            {item.perfos}
                        </div>
                    <div class="flex flex-col w-full">
                        <span class="text-xs font-bold">Pago</span>
                            ${item.pagos}
                        </div>
                    </div>	
                </div>
                {/if}
            {/each}
        </div>
    </div>
    <!--historial-->
    <div class='w-full flex flex-col items-center'>
        <div class="w-full p-2 bg-white overflow-hidden h-full rounded shadow">
            <div class="w-full mb-2 flex items-center justify-between">
                <button on:click={anteriorFecha} class="bg-red-500 text-white flex items-center justify-center rounded shadow p-2 hover:bg-red-300">
                    <i class="ri-arrow-left-line" />
                </button>
                <p on:click={reset} class="font-bold">{texto}</p>
                <button on:click={siguienteFecha} class="bg-red-500 text-white flex items-center justify-center rounded shadow p-2 hover:bg-red-300">
                    <i class="ri-arrow-right-line" />
                </button>
            </div>
            <div class="w-full flex items-center justify-between">
                <div class="font-bold text-xs w-full flex items-center justify-center">Detalle</div>
                <div class="font-bold text-xs w-full flex items-center justify-center">Artista</div>
                <div class="font-bold text-xs w-full flex items-center justify-center">Monto</div>
            </div>
            <div class="w-full bg-gray-100 flex flex-col">
                {#each $historial as item}
                    <div class={`w-full cursor-pointer flex items-center justify-between border-b border-gray-400 p-2 ${item.detalle}`}>
                        <div class="w-full">{item.detalle}{(item.cantidad?` x${item.cantidad}`:``)}</div>
                        {#if item.empleado}
                            <div class="w-full">{item.empleado}</div>
                        {/if}
                        {#if item.monto}
                            <div class="font-bold">{(item.tipo == "Gasto" || item.tipo == "Pago"  || item.tipo == "CambioCierre"? "-":"")}${item.monto}</div>
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
        
    </div>
</div>
<style>
    .h-px-300{
        height: 300px;
        max-height: 300px;
    }
    .Tatuaje{
        background: rgba(255,0,0,.5);
    }
    .Perforación{
        background: pink;
    }
</style>